(function () {
  if (window.__mt21Init) return;
  window.__mt21Init = true;

  function showAll(els) {
    els.forEach(function (el) { el.classList.add('mt21-visible'); });
  }

  function initReveal() {
    var els = document.querySelectorAll('.mt21-reveal:not(.mt21-visible)');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showAll(els);
      return;
    }
    if (!('IntersectionObserver' in window)) {
      showAll(els);
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt21-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) { obs.observe(el); });

    // Red de seguridad: si por cualquier motivo (vista previa del editor,
    // secciones que se cargan después, temporización) el observador no
    // llega a activar un elemento, lo mostramos igual a los 1.5s para que
    // el texto nunca se quede invisible.
    setTimeout(function () {
      showAll(document.querySelectorAll('.mt21-reveal:not(.mt21-visible)'));
    }, 1500);
  }

  function initFaqAccordion() {
    var items = document.querySelectorAll('.mt21-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.mt21-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('mt21-faq-abierto');
        items.forEach(function (i) { i.classList.remove('mt21-faq-abierto'); });
        if (!isOpen) item.classList.add('mt21-faq-abierto');
      });
    });
  }

  function initAll() {
    initReveal();
    initFaqAccordion();
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initReveal);
  document.addEventListener('shopify:section:load', initAll);

  // El editor de Shopify a veces vuelve a pintar la vista previa sin
  // disparar los eventos anteriores. Este observador detecta secciones
  // nuevas o reemplazadas y vuelve a activar el texto en ellas.
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { initReveal(); });
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();

(function () {
  if (window.__mtGaleriaInit) return;
  window.__mtGaleriaInit = true;

  function initGalerias() {
    var galerias = document.querySelectorAll('[data-mt21-galeria]');
    galerias.forEach(function (galeria) {
      var minis = galeria.querySelectorAll('[data-mt21-mini]');
      var fotos = galeria.querySelectorAll('[data-mt21-foto-principal]');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var idx = mini.getAttribute('data-index');
          minis.forEach(function (m) { m.classList.remove('mt21-activa'); });
          mini.classList.add('mt21-activa');
          fotos.forEach(function (foto) {
            if (foto.getAttribute('data-index') === idx) {
              foto.classList.add('mt21-activa');
            } else {
              foto.classList.remove('mt21-activa');
            }
          });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initGalerias);
  document.addEventListener('shopify:section:load', initGalerias);
})();
